import { Link } from 'react-router-dom';

interface HeroProps {
  onExploreClick?: () => void;
}

export default function Hero({ onExploreClick }: HeroProps) {
  return (
    <div className="relative min-h-screen">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bd14aab25e03d662de14b209274590dc.jpg"
          alt="Maseru, Lesotho"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 min-h-screen flex items-center">
        <div className="w-full px-4 sm:px-8 lg:px-20 pt-28 pb-20">
          <div className="max-w-4xl mx-auto text-center">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-6">
              <div className="w-2 h-2 bg-[#3782df] rounded-full"></div>
              <span className="text-white text-sm font-medium">Innovative Business Solutions</span>
            </div>

            {/* Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Empowering Growth Through
              <span className="block text-[#3782df] mt-2">Technology &amp; Strategy</span>
            </h1>

            {/* Subtitle */}
            <p className="text-base sm:text-lg text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
              From web development and data science to agribusiness solutions and financial systems — we deliver end-to-end support that drives real results.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
              <button
                onClick={onExploreClick}
                className="w-full sm:w-auto px-8 py-3.5 bg-[#3782df] text-white text-sm font-medium rounded-lg hover:bg-[#2968c4] transition-colors whitespace-nowrap cursor-pointer"
              >
                Explore Services
              </button>
              <Link
                to="/contact"
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white text-sm font-medium rounded-lg border border-white/20 hover:bg-white/20 transition-colors whitespace-nowrap text-center"
              >
                Get in Touch
              </Link>
            </div>

            {/* Stats Cards */}
            <div className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide">
              <div className="flex-shrink-0 w-64 sm:w-auto sm:flex-1 bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 snap-center">
                <div className="text-3xl sm:text-4xl font-bold text-white mb-2">20+</div>
                <div className="text-sm text-white/80">Projects Delivered</div>
              </div>
              <div className="flex-shrink-0 w-64 sm:w-auto sm:flex-1 bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 snap-center">
                <div className="text-3xl sm:text-4xl font-bold text-white mb-2">98%</div>
                <div className="text-sm text-white/80">Client Satisfaction</div>
              </div>
              <div className="flex-shrink-0 w-64 sm:w-auto sm:flex-1 bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 snap-center">
                <div className="text-3xl sm:text-4xl font-bold text-white mb-2">24/7</div>
                <div className="text-sm text-white/80">Support Available</div>
              </div>
              <div className="flex-shrink-0 w-64 sm:w-auto sm:flex-1 bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 snap-center">
                <div className="text-3xl sm:text-4xl font-bold text-white mb-2">10+</div>
                <div className="text-sm text-white/80">Years Experience</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </div>
  );
}
